import { useNavigate, Navigate } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../../core/providers/AuthProvider';
import { useApprovalStatus } from '../hooks/useApprovalStatus';
import Spinner from '../../../shared/components/Spinner';

// Where a teacher lands when a super admin has deactivated their account (teachers.approved).
function InactiveAccountPage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { approved, loading } = useApprovalStatus(true);

  const handleBackToHome = async () => {
    await signOut();
    navigate('/');
  };

  if (loading) {
    return <Spinner />;
  }

  if (approved) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-dvh flex flex-col bg-gray-200 sm:items-center sm:justify-center sm:px-4 sm:py-8">
      <div className="w-full h-dvh sm:h-auto sm:max-w-sm bg-white sm:rounded-lg sm:border sm:border-gray-200 p-8 space-y-3 flex flex-col justify-center sm:justify-normal text-center">

        <div className="flex justify-center">
          <ClockIcon className="h-12 w-12 text-[#4ea6d0]" />
        </div>

        <h1 className="text-xl font-semibold text-[#0b4a71]">Account Inactive</h1>

        <p className="text-sm text-gray-500">
          Your account isn't active right now, so you can't open the dashboard. Please contact
          the school's administrator to have it activated.
        </p>

        <button
          type="button"
          onClick={handleBackToHome}
          className="w-full bg-[#4ea6d0] text-white rounded-md py-4 text-lg font-medium hover:bg-[#0b4a71] active:bg-[#0b4a71]"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default InactiveAccountPage;
